const e = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="m13.186 2.081 5 7 1.628-1.162-5-7-1.628 1.162Zm3.663 9.178-7-6 1.302-1.518 7 6-1.302 1.518ZM7.074 9.905l8.5 4 .852-1.81-8.5-4-.852 1.81Zm7.71 6.571-9-2 .433-1.952 9 2-.434 1.952ZM3.5 15h-2v8h18v-8h-2v6h-14v-6ZM6 19h9v-2H6v2Z" clip-rule="evenodd"></path></svg>';
export {
  e as default
};
